module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var attributes = Html.attributes(_.reduce(_.pick(item, 'id', 'name', 'groupname'), function(result, value, key) {
    result['data-' + key] = value;
    return result;
}, {}));

    ; __append("\n\n<li name=\"item\" class='gis-menu-list-item gis-menu-list-item-exp ")
    ; __append(escapeFn( item.classes ))
    ; __append("' ")
    ; __append( attributes )
    ; __append(">\n    <div class='gis-menu-list-root'>\n        <span class=\"icon-drag_handle icon-24 gis-menu-item-handle\"></span>\n        <label on-click=\"onItemClick\" ")
    ; __append( attributes )
    ; __append(">\n            <input type='checkbox' state-holder> ")
    ; __append( item.html || item.label )
    ; __append("\n        </label>\n\n        <div class='gis-menu-list-hdl'>\n            <div></div>\n        </div>\n    </div>\n    <div class='gis-menu-list-inn'>\n        <div name=\"inner\" class='gis-menu-list-inn-wrp'>\n            <div class='map-menu-slider gis-layer-opacity section'>\n                <label>Прозрачность слоя</label>\n\n                <div class='flex flex-middle'>\n                    <div class='flex-item'>\n                        <!-- todo use control -->\n                        <div class=\"slider\" name=\"opacity\" value=\"")
    ; __append(escapeFn( item.opacity ))
    ; __append("\" min=\"0\" max=\"100\" units=\"%\" ")
    ; __append( attributes )
    ; __append("></div>\n                    </div>\n                    <div class='flex-none'>\n                        <span class='map-menu-slider-res' name=\"opacity-value\">\n                            ")
    ; __append(escapeFn( item.opacity ))
    ; __append("%\n                        </span>\n                    </div>\n                </div>\n            </div>\n\n            ")
    ;  if (item.strokeWidth !== false) { 
    ; __append("\n            <div class='map-menu-slider gis-layer-stroke-width section'>\n                <label>Толщина линий</label>\n\n                <div class='flex flex-middle'>\n                    <div class='flex-item'>\n                        <!-- todo use control -->\n                        <div class=\"slider\" name=\"stroke-width\" value='")
    ; __append(escapeFn( item.strokeWidth ))
    ; __append("' min='1' max='50' ")
    ; __append( attributes )
    ; __append("></div>\n                    </div>\n                    <div class='flex-none'>\n                        <span class='map-menu-slider-res' name=\"stroke-width-value\">\n                            ")
    ; __append(escapeFn( item.strokeWidth ))
    ; __append("\n                        </span>\n                    </div>\n                </div>\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ; 
            var showControls = _.some(item.controls);
            
    ; __append("\n            ")
    ;  if (showControls) { 
    ; __append("\n            <div class=\"gis-layer-controls section\">\n                ")
    ;  if (_.get(item, "controls.import")) { 
    ; __append("\n                <div class=\"gl-pointer control\" on-click=\"onImportClick\" ")
    ; __append( attributes )
    ; __append(">\n                    <span class=\"icon-cloud-upload icon\"></span>Импортировать\n                </div>\n                ")
    ;  } 
    ; __append("\n\n                ")
    ;  if (_.get(item, "controls.export")) { 
    ; __append("\n                <div class=\"gl-pointer control\" on-click=\"onExportClick\" ")
    ; __append( attributes )
    ; __append(">\n                    <span class=\"icon-cloud-download icon\"></span>Экспортировать\n                </div>\n                ")
    ;  } 
    ; __append("\n\n                ")
    ;  if (_.get(item, "controls.edit")) { 
    ; __append("\n                <div class=\"gl-pointer control\" on-click=\"onEditClick\" ")
    ; __append( attributes )
    ; __append(">\n                    <span class=\"icon-pencil icon\"></span>Редактировать\n                </div>\n                ")
    ;  } 
    ; __append("\n                ")
    ;  if (_.get(item, "controls.remove")) { 
    ; __append("\n                <div class=\"gl-pointer control\" on-click=\"onRemoveClick\" ")
    ; __append( attributes )
    ; __append(">\n                    <span class=\"icon-trash-o icon\"></span>Удалить\n                </div>\n                ")
    ;  } 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            <!-- filters based on class attributes -->\n            ")
    ;  if (!_.isEmpty(item.filters)) { 
    ; __append("\n            <div class=\"gis-layer-filters section\" name=\"layer-filters\"></div>\n            ")
    ;  } 
    ; __append("\n\n            <!-- custom styles -->\n            ")
    ;  if (_.size(item.namedStyles)) { 
    ; __append("\n            <div class=\"gis-layer-styles section\">\n                <select class=\"menu-item-style-select\" name=\"style-name\" ")
    ; __append( attributes )
    ; __append(">\n                    ")
    ;  _.each(item.namedStyles, function(style, key) { 
    ; __append("\n                    <option value=\"")
    ; __append(escapeFn( key ))
    ; __append("\">")
    ; __append(escapeFn( style.title ))
    ; __append("</option>\n                    ")
    ;  }) 
    ; __append("\n                </select>\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (!_.isEmpty(item.mapreports)) { 
    ; __append("\n            <div class=\"gis-layer-mapreports section\">\n                ")
    ;  _.each(item.mapreports, function(report){ 
    ; __append("\n                <div>\n                    <label>\n                        ")
    ; 
                          var data = Html.attributes(_.reduce(report, function(result, value, key) {
                              result['data-' + key] = value;
                              return result;
                          }, {}));
                          
    ; __append("\n                        <input type=\"checkbox\" name=\"show-mapreport\" value=\"")
    ; __append(escapeFn( report.name ))
    ; __append("\" on-change=\"onShowMapReportChange\" ")
    ; __append( data )
    ; __append(" /> ")
    ; __append(escapeFn( report.title ))
    ; __append("\n                    </label>\n                </div>\n                ")
    ;  }) 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n</li>\n")
  }
  return __output.join("");

}